import Query from '../common/Query';
import PRODUCTS_QUERY from './products/queries/PRODUCTS_QUERY';
import GalleryProductCard from './GalleryProductCard';

const GalleryProducts = (props: any) => {
    const handleSelected = props?.handleSelected;
    const selectedItems = props.selectedItems;
    const listItems = () => <Query query={PRODUCTS_QUERY}>
        {({ data: { products } }: { data: { products: any[] } }) => {
            return products.map((product, i) =>
                <GalleryProductCard product={product} key={product.code} selectedItems={selectedItems} handleSelected={handleSelected} />
            );
        }}
    </Query>;

    return <div className="d-flex flex-wrap align-items-center">
        {listItems()}
    </div>;
};

export default GalleryProducts;
